import { VendorContactsListVendor } from '../../components/Vendor';
import { usePageTitle } from '../../hooks';

export function Contacts() {
  usePageTitle('vendor:contact.title');
  return <VendorContactsListVendor />;
}
